var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageWarning64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Message/Warning64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconWarning64",
    transform: "translate(-216.000000, -132.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "04-Honeycomb-Foundation/icon/Message/Warning64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconWarning",
    transform: "translate(3.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8659858,-1.21140359 L59.1191616,49.5003236 C59.3951253,49.9787193 59.2310217,50.5902484 58.7526259,50.8662121 C58.6006837,50.9538604 58.4283594,51 58.2529495,51 L-0.253402148,51 C-0.805686898,51 -1.25340215,50.5522847 -1.25340215,50 C-1.25340215,49.82459 -1.20726251,49.6522658 -1.11961428,49.5003236 L28.1335615,-1.21140359 C28.4095252,-1.68979934 29.0210544,-1.85390295 29.4994501,-1.57793927 C29.6517216,-1.49010113 29.7781476,-1.36367505 29.8659858,-1.21140359 Z",
    id: "Triangle",
    fill: "#F95200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Stroke",
    fill: "#FFFFFF",
    x: 27,
    y: 18,
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Dot",
    fill: "#FFFFFF",
    x: 27,
    y: 40,
    width: 4,
    height: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWarning64);
export default __webpack_public_path__ + "static/media/messageWarning64.b381dc32d53ab635598fff2b8ba086ba.svg";
export { ForwardRef as ReactComponent };